export default __webpack_public_path__ + "images/chipper-5826f8c4b5f280c350091f0829b734bb.png";